import { SitePermissionLevel } from "../../api/types/member";

export type PermissionOption = {
  value: SitePermissionLevel;
  label: string;
};

export const permissionLabelMap: Record<number, string> = {
  0: "직원",
  1: "메니저",
  2: "지점주",
  3: "파트너",
  4: "배송 담당자",
  5: "마케터",
  6: "제휴사",
};

export const ALL_PERMISSION_OPTIONS: PermissionOption[] = [
  { value: 0, label: "직원" },
  { value: 1, label: "메니저" },
  { value: 2, label: "지점주" },
  { value: 3, label: "파트너" },
  { value: 4, label: "배송 담당자" },
  { value: 5, label: "마케터" },
  { value: 6, label: "제휴사" },
];

const MANAGER_PERMISSION_VALUES = new Set<number>([0, 1]);

export const getPermissionOptions = (actorPermission: number): PermissionOption[] => {
  if (actorPermission === 2) {
    return ALL_PERMISSION_OPTIONS;
  }
  if (actorPermission === 1) {
    return ALL_PERMISSION_OPTIONS.filter((option) => MANAGER_PERMISSION_VALUES.has(option.value));
  }
  return [];
};

export const ensureCurrentPermissionOption = (
  options: PermissionOption[],
  currentPermission: number
): PermissionOption[] => {
  if (options.some((option) => option.value === currentPermission)) {
    return options;
  }
  return [
    ...options,
    {
      value: currentPermission as SitePermissionLevel,
      label: permissionLabelMap[currentPermission] || `권한 ${currentPermission}`,
    },
  ].sort((a, b) => a.value - b.value);
};
